<template>
  <div>
    <download-excel
      style="display: inline-block"
      :data="data1"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="已支付图表.xls"
    >
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0', display: 'inline-block' }"
      >
        Excel导出
      </a-button>
    </download-excel>
    <span style="margin-left: 20px;">当前查询订单查询合计金额：{{ sumPrice }}</span>
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="goodsRecord" slot-scope="text, record">
        <span>{{ parseJson(record.goodsRecord) }}</span>
      </template>
      <template slot="operate" slot-scope="text, record">
        <a
          href="javascript:;"
          v-on:click.prevent="
            topage(`/home/exchangeOrder/orderDetails?orderNo=${record.orderNo}`)
          "
          >订单详情</a
        >
        <span

          style="margin-left: 10px;color: red;cursor: pointer;"
          @click="refund(record)"
          >退款</span
        >
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { alreadyPay, alreadyPaySeach } from "@/api/packageApi.js";
import { payOrderRefund } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
const columns = [
  {
    title: " 订单编号",
    dataIndex: "orderNo",
    align: "center",
    sorter: true
  },
  {
    title: "订单类型",
    dataIndex: "goodsRecord",
    align: "center",
    scopedSlots: { customRender: "goodsRecord" }
  },
  {
    title: "订单数量",
    dataIndex: "goodsNum",
    align: "center"
  },
  {
    title: "订单金额",
    dataIndex: "pricePay",
    sorter: true,
    align: "center"
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    sorter: true
  },
  {
    title: "用户ID",
    dataIndex: "userUid",
    align: "center",
    sorter: true
  },
  {
    title: "支付时间",
    dataIndex: "createTime",
    align: "center",
    sorter: true
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    scopedSlots: { customRender: "operate" }
  }
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        订单编号: "orderNo",
        商品类型: "goodsInfo",
        支付金额: "pricePay",
        商品封面: "avatar",
        所属门店: "shopName",
        用户ID: "userUid",
        订单状态: "statusShopStr",
        下单时间: "createTime"
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      visible: false,
      sumPrice: 0,
    };
  },
  props: ["formInline"],
  mounted() {
    this.getAlreadyPayData();
  },

  methods: {
    parseJson(item){
      
      let i = JSON.parse(item)[0];
      if(i.typeSonId === 654){
        return "代币套餐";
      }else if(i.typeSonId === 655){
        return "门票套餐";
      }
    },
    refund(record) {
      let that = this;
      that.$confirm({
        title: "提示",
        content: "是否退款",
        onOk() {
          let params = {
            fun: "Refund",
            uid: record.userUid,
            orderId: record.orderNo,
            refundAmount: record.pricePay
          };
          console.log("refund params: ", params);
          return new Promise((resolve, reject) => {
            payOrderRefund(params).then(res => {
              console.log("refund res: ", res);
              if (res.success) {
                message.success("退款成功");
                that.handleTableChange(that.pagination);
                setTimeout(resolve, 1000);
              } else {
                message.error(res.info);
              }
            });
          }).catch((e) => console.log("err:"+e));
        },
        onCancel() {}
      });
    },
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const userUid = this.formInline.userUid;
      const orderNo = this.formInline.orderNo;
      const shopId = this.formInline.shopId;
      const endDate = this.formInline.endDate;
      const startDate = this.formInline.startDate;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await alreadyPaySeach(1, 1, userUid, orderNo, shopId, endDate, startDate);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await alreadyPaySeach(totalCount, 1, userUid, orderNo, shopId, endDate, startDate);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await alreadyPaySeach(pageSize, page, userUid, orderNo, shopId, endDate, startDate);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath, record) {
      console.log(record);
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      alreadyPay(
        10,
        this.pagination.current,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate
      ).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
        console.log(res);
      });
    },
    getAlreadyPayData() {
      this.loading = true;
      alreadyPay(
        10,
        1,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate,
      ).then(res => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.sumPrice = res.data[0].sumPrice;
        console.log(res);
        this.loading = false;
      });
    },
    // 查询
    query() {
      this.sumPrice = 0;
      console.log("e", this.formInline);
      this.loading = true;
      alreadyPaySeach(
        10,
        1,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.shopId,
        this.formInline.endDate,
        this.formInline.startDate,
      ).then(res => {
        this.loading = false;
        console.log(1111);
        console.log(res);
        this.data = res.data;
        this.pagination.total = res.count;
        this.sumPrice = res.data[0].sumPrice;
      });
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/orderManagement/payForTheOrder/payForTheOrderContent.vue